import { ForwardedRef } from 'react';

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const sleep = (ms: number) =>
  new Promise((r) => {
    setTimeout(r, ms);
  });

export const optionalArrayItem = <T>(item?: T) => (item ? [item] : []);

export const mergeRefs =
  <T>(...refs: Array<ForwardedRef<T> | undefined>) =>
  (node: T | null) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(node);
        return;
      }
      if (!ref) return;
      const mutableRef = ref;
      mutableRef.current = node;
    });
  };

export class StrictMap<T extends object> extends Map<keyof T, T[keyof T]> {
  override set<K extends keyof T>(key: K, value: T[K]): this {
    return super.set(key, value);
  }

  override get<K extends keyof T>(key: K): T[K] | undefined {
    return super.get(key) as T[K] | undefined;
  }
}
